import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Combobox } from '@salesforce/design-system-react';

import './AssetArchiving.scss';

class AssetArchiving extends Component {
  currentSelection() {
    const type = this.props.periodChanged
      ? this.props.tempArchivePeriod
        ? this.props.tempArchivePeriod
        : this.props.archivePeriod
      : this.props.archivePeriod
      ? this.props.archivePeriod
      : -1;

    return type ? [this.selectionFor(type)] : [];
  }

  selectionFor(archivePeriod) {
    const { formatMessage } = this.props.intl;
    const i18nKey = 'components.ecs.rules.archiving.timespans';
    return {
      id: archivePeriod.toString(),
      label: formatMessage({ id: `${i18nKey}.${archivePeriod}` }),
      value: archivePeriod
    };
  }

  options() {
    const types = [-1, 30, 60, 90, 180, 365, 455];
    return types.map(this.selectionFor.bind(this));
  }

  render() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="archive-period">
        <Combobox
          classNameContainer="archive-period-combobox"
          labels={{
            label: formatMessage({
              id: 'components.ecs.rules.archiving.label'
            })
          }}
          readonly
          options={this.options()}
          selection={this.currentSelection()}
          events={{
            onSelect: (evt, data) => {
              if (!data.selection[0]) {
                return null;
              }

              this.props.onSettingChanged(
                data.selection[0].id !== this.props.archivePeriod.toString(),
                data.selection && data.selection[0] && data.selection[0].value
              );
            }
          }}
          variant="readonly"
        />
      </div>
    );
  }
}

AssetArchiving.propTypes = {
  archivePeriod: PropTypes.number,
  tempArchivePeriod: PropTypes.number,
  onSettingChanged: PropTypes.func.isRequired,
  periodChanged: PropTypes.bool,
  intl: intlShape.isRequired
};

export default injectIntl(AssetArchiving);
